import { Routes } from '@angular/router';
import {
  LogoutComponent,
  TrackingTableComponent,
} from '@upassignations/feature';
import { ArchivesComponent } from '@upassignations/feature';
import { LogsTableComponent } from '@upassignations/feature';
import { NotificationCenterComponent } from '@upassignations/feature';
import { AuthGuard } from './libs/core/src/lib/guards/auth.guard';
import { UnauthorisedComponent } from './libs/feature/src/lib/components/unauthorised/unauthorised.component';

export const routes: Routes = [
  { path: '', redirectTo: 'tableau-de-suivi', pathMatch: 'full' },
  { path: 'unauthorised', component: UnauthorisedComponent },
  { path: 'logout', component: LogoutComponent },
  {
    path: 'tableau-de-suivi',
    component: TrackingTableComponent,
    canActivate: [AuthGuard],
  },
  { path: 'archives', component: ArchivesComponent, canActivate: [AuthGuard] },
  {
    path: 'tableau-de-logs',
    component: LogsTableComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'centre-de-notifications',
    component: NotificationCenterComponent,
    canActivate: [AuthGuard],
  },
];
